import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material"
import ArgonTypography from "components/ArgonTypography"
import { CustomDescrypt } from "global/func";
import { postDataWithResponse } from "global/postFunc";
import { useEffect, useState } from "react";
import userStore from "store/userStore";

const listBulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const CapaianBulanan = ({ dataKomponen }) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    useEffect(() => {
        dataKomponen.id !== undefined && reqRealisasi()
        console.log(dataKomponen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    const [listRealisasi, setListRealisasi] = useState([])

    const reqRealisasi = () => {
        addReq()
        postDataWithResponse(
            `/admin-opd/realisasi/filter`,
            {
                id_komponen: dataKomponen.id
            },
            decryptedUser,
            (res) => {
                setListRealisasi(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    return (
        <Card>
            <CardHeader
                title={
                    <ArgonTypography variant='subtitle2' fontWeight="bold">Capaian Bulanan</ArgonTypography>
                }
            />
            <CardContent>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                No
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Bulan
                            </TableCell>
                            <TableCell align="center" colSpan={2} sx={{ fontSize: 'small' }}>
                                Realisasi Keuangan
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Realisasi Fisik
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Status Pelaksanaan
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Permasalahan
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" sx={{ fontSize: 'small' }}>
                                Nominal (Rp)
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small' }}>
                                %
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            listBulan.map((bulan, index) => (
                                <TableRow key={index} >
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>{index + 1}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>{bulan}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            listRealisasi[index]?.realisasi_keuangan ?

                                                parseInt(listRealisasi[index].realisasi_keuangan).toLocaleString?.('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })

                                                : ''
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            listRealisasi[index]?.realisasi_keuangan_persen ? listRealisasi[index].realisasi_keuangan_persen + '%' : ''
                                        }
                                    </TableCell>
                                    {/* <TableCell align="center" sx={{ fontSize: 'small' }}>
                                                {
                                                    listRealisasi[index]?.realisasi_fisik ? listRealisasi[index].realisasi_fisik : ''
                                                }
                                            </TableCell> */}
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume) > 1 ?
                                                listRealisasi[index]?.realisasi_fisik_persen ? listRealisasi[index].realisasi_fisik + ' (' + listRealisasi[index].realisasi_fisik_persen + '%)' : ''
                                                :
                                                listRealisasi[index]?.realisasi_fisik_persen ? listRealisasi[index].realisasi_fisik_persen + '%' : ''
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            listRealisasi[index]?.status_pelaksanaan ? listRealisasi[index].status_pelaksanaan : ''
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            listRealisasi[index]?.permasalahan ? listRealisasi[index].permasalahan : ''
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                Total
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {
                                    parseInt(dataKomponen.realisasi_keuangan).toLocaleString?.('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    })
                                }
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {dataKomponen.realisasi_keuangan_persen} %
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {dataKomponen.realisasi_fisik_persen} %
                            </TableCell>
                            <TableCell align="center" colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>

                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </CardContent>
        </Card>
    )
}

export default CapaianBulanan